"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UICookiePrefix = exports.Platform = void 0;
/**
 * Represents the platform values used for sending logging events.
 */
let Platform = exports.Platform = /*#__PURE__*/function (Platform) {
  Platform["WEB"] = "web";
  Platform["ANDROID"] = "android";
  Platform["IOS"] = "ios";
  Platform["TEQUILA"] = "tequila";
  return Platform;
}({});
/**
 * Represents the UI prefix values for different platforms in the UI cookie.
 */
let UICookiePrefix = exports.UICookiePrefix = /*#__PURE__*/function (UICookiePrefix) {
  UICookiePrefix["ANDROID"] = "android";
  UICookiePrefix["IOS"] = "ios";
  UICookiePrefix["TEQUILA"] = "tequila";
  return UICookiePrefix;
}({});